<template>
  <chart :data="data" />
</template>
<script>
import Chart from '../Chart'
import collect from 'collect.js'

export default {
  components: {
    Chart,
  },
  props: ['data'],
  data() {
    return {
      value: 'amount',
      chartValues: {
        amount: { title: 'Množstvo', decimal: 3, suffix: 'MWh' },
        totalPrice: { title: 'Celková cena', decimal: 2, suffix: '€ bez dph' },
      },
    }
  },
  computed: {
    monthlySeries() {
      let data = []
      data = this.data.filter((item) => {
        return !item.total
      })
      return data.map((item, k) => {
        return {
          name: item.year,
          type: 'column',
          visible: k <= 2,
          data: item.data.map((val) => {
            switch (this.value) {
              case 'amount':
                return val.amountVT + val.amountNT
              case 'totalPrice':
                return val.totalPrice
            }
          }),
        }
      })
    },
    yearlySeries() {
      return this.data.map((item) => {
        return item.data.reduce((sum, item) => {
          switch (this.value) {
            case 'amount':
              return sum + item.amountVT + item.amountNT
            case 'totalPrice':
              return sum + item.totalPrice
          }
        }, 0)
      })
    },
  },
}
</script>
